<template>
    <div class="gg">
      <!-- MV - Gain Guru -->
        <cq-header headertext="MEET MANAN VASA - THE GAIN GURU"></cq-header>

        <cqtextimagesection direction = "R" :imagesrc="images.gg" showTLRBorder="true">
          <cq-paratext><b> Primarily, Manan Vasa gets hired for making people walk their talk, compassionately. </b> </cq-paratext>
          <cq-paratext> A Chartered Accountant &amp; an IIM Alumnus, Manan's Core Competency is Productivity and Leadership. He has coached &amp; consulted over <b class="red">15,000 people</b> &amp; over <b class="red">500 businesses</b> over the last <b class="red">15 years.</b></cq-paratext>
          <cq-paratext> Having realized that what is really missing is implementation, he invented the <b class="red">Colloquium</b> Eco-system and the <b class="red">'Make it Happen Framework'</b> to get people to produce <b class="red">UNPRECEDENTED RESULTS</b> on a solid foundation of habits in the last 3 years alone  over a <b class="red">1000 people</b> have turned around their businesses &amp; lives through his Gain Livinar </cq-paratext>
          <h5><b> SEE WHAT PEOPLE HAVE TO SAY ABOUT HIM. </b></h5>
          <cq-btn :textButtonText="true" class="text-center readmore"> READ MORE </cq-btn>
        </cqtextimagesection>
    </div>
</template>

<script>
import CQHeader from '../../components/ui/CQHeader.vue'
import CQButton from '../../components/ui/CQButton.vue'
import CQPara from '../../components/ui/CQPara.vue'
import CQTextImageSection from '../../components/ui/CQTextImageSection.vue'

// Import Images
import gg from '../../assets/image/home/gg.png'

export default {
    components: {
        'cq-header' : CQHeader,
        'cq-btn' : CQButton,
        'cq-paratext' : CQPara,
        'cqtextimagesection': CQTextImageSection
    },
  data() {
    return {
      images: { 
        gg
      }
    }
  }
}
</script>

<style scoped>
.red{
  color: var(--primary-color);
}

  h5{
    padding-bottom: 3%;
  }

  .gg >>> p{
    font-size: 18px;
    font-family: 'Seravek-Light';
  }

.gg >>> .grey{
  background-image: linear-gradient(var(--secondary-color)45%, #C7C8CA);
  margin-bottom: 20px;
}


.gg >>> .top-right-borders{
  border-right: 4px solid var(--primary-color);
  border-top: 4px solid var(--primary-color);
  width: 23%;
  right:20px;
  height: 150px;
  position: absolute;
}

.gg >>> .gg2{
  padding-top: 45px;
}


/* Desktop View */
@media only screen and (min-width: 992px){
  .gg >>> .gg1{
    padding-left: 0 !important;
  }

  .gg >>> #tgg-img{
    padding: 30px 30px 0 0 !important;
  }

  .gg >>> .gg2{
    padding-right: 104.5px !important;
    padding-top: 45px;
  }

  /* .gg >>> .readmore{
  padding-top: 0;
} */
}

@media only screen and (max-width: 992px){
  .readmore{
    padding-bottom: 5%;
  }
}
</style>